import { render } from "./UserCenterPage.vue?vue&type=template&id=e5cdef76&scoped=true"
import script from "./UserCenterPage.vue?vue&type=script&lang=js"
export * from "./UserCenterPage.vue?vue&type=script&lang=js"

import "./UserCenterPage.vue?vue&type=style&index=0&id=e5cdef76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5cdef76"]])

export default __exports__